module.exports = __webpack_public_path__ + "static/media/34.102d4eaf.png";